'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defaultResourceReducer = require('../utils/services/http/resources/reducers/defaultResourceReducer');

var _defaultResourceReducer2 = _interopRequireDefault(_defaultResourceReducer);

var _elementConstants = require('../../common/elements/elementConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Reducers
exports.default = function (state, action) {
    var updatedState = (0, _defaultResourceReducer2.default)(state, action);

    if (action.type === _elementConstants.ELEMENT_CREATE) {
        return updatedState.set('fetched', true).set('fetching', false);
    }

    return updatedState;
};

// Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/element/elementsResourceReducer.js
// module id = 1977
// module chunks = 0